import find from "lodash/find";

export const DASHBOARD_PAGE = "/";
export const MESSAGES_PAGE = "/messages";
export const PRODUCT_DETAILS_PAGE = "/product/";
export const SEARCH_PAGE = "/search";
export const CART_PAGE = "/cart";
export const PRODUCT_RECOMMENDATIONS_PAGE = "/product-recommendations";
export const ORDERS_PAGE = "/orders";

export const A_CART_SUMMARY_PAGE = "A_CART_SUMMARY_PAGE"; // Generic slug since multiple pages can have the cart summary
export const CART_SUMMARY_PATHNAMES = [
  PRODUCT_DETAILS_PAGE,
  SEARCH_PAGE,
  PRODUCT_RECOMMENDATIONS_PAGE,
];

export default function isOnPage(pageSlug: string, pathname: string): boolean {
  if (pageSlug === A_CART_SUMMARY_PAGE) {
    return !!find(CART_SUMMARY_PATHNAMES, (p) => pathname.startsWith(p));
  }
  if (pageSlug === MESSAGES_PAGE || pageSlug === PRODUCT_DETAILS_PAGE) {
    return pathname.startsWith(pageSlug);
  }
  if (pageSlug === DASHBOARD_PAGE || pageSlug === ORDERS_PAGE) {
    return pathname === pageSlug;
  }
  if (pageSlug === CART_PAGE) {
    return pathname.startsWith(pageSlug);
  }

  return false;
}
